var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 72 72",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.94 7.39C66.11 7.39 67.06 8.34 67.06 9.51C67.06 20.6 67.06 51.75 67.06 62.84C67.06 64 66.11 64.95 64.94 64.95C52.94 64.95 19.06 64.95 7.06 64.95C5.89 64.95 4.94 64 4.94 62.84C4.94 51.75 4.94 20.6 4.94 9.51C4.94 8.34 5.89 7.39 7.06 7.39C19.06 7.39 52.94 7.39 64.94 7.39Z",
    id: "b4xikTSVr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.64 18.1C24.65 20.72 24.16 24.49 21.53 26.51C18.9 28.53 15.13 28.03 13.12 25.4C11.1 22.77 11.6 19 14.23 16.99C16.85 14.97 20.62 15.47 22.64 18.1Z",
    id: "bqUhWSCBc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.88 36.14C23.88 39.45 21.19 42.14 17.88 42.14C14.57 42.14 11.88 39.45 11.88 36.14C11.88 32.83 14.57 30.14 17.88 30.14C21.19 30.14 23.88 32.83 23.88 36.14Z",
    id: "c17inI8nhP"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.88 50.84C23.88 54.15 21.19 56.84 17.88 56.84C14.57 56.84 11.88 54.15 11.88 50.84C11.88 47.52 14.57 44.84 17.88 44.84C21.19 44.84 23.88 47.52 23.88 50.84Z",
    id: "afgt56bsj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.32 19.25C59.32 19.25 60.13 20.06 60.13 21.06C60.13 21.7 60.13 21.8 60.13 22.44C60.13 23.44 59.32 24.25 58.32 24.25C52.12 24.25 35.32 24.25 29.12 24.25C28.12 24.25 27.31 23.44 27.31 22.44C27.31 21.8 27.31 21.7 27.31 21.06C27.31 20.06 28.12 19.25 29.12 19.25C35.32 19.25 52.12 19.25 58.32 19.25Z",
    id: "e14M2lI70M"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.67 33.79C59.67 33.79 60.48 34.6 60.48 35.6C60.48 36.24 60.48 36.35 60.48 36.98C60.48 37.98 59.67 38.79 58.67 38.79C52.47 38.79 35.68 38.79 29.48 38.79C28.48 38.79 27.67 37.98 27.67 36.98C27.67 36.35 27.67 36.24 27.67 35.6C27.67 34.6 28.48 33.79 29.48 33.79C35.68 33.79 52.47 33.79 58.67 33.79Z",
    id: "b7abAKAWgE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.32 48.34C59.32 48.34 60.13 49.15 60.13 50.15C60.13 50.78 60.13 50.89 60.13 51.53C60.13 52.53 59.32 53.34 58.32 53.34C52.12 53.34 35.32 53.34 29.12 53.34C28.12 53.34 27.31 52.53 27.31 51.53C27.31 50.89 27.31 50.78 27.31 50.15C27.31 49.15 28.12 48.34 29.12 48.34C35.32 48.34 52.12 48.34 58.32 48.34Z",
    id: "g2GRCIzFXr"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4xikTSVr",
    opacity: 1,
    fillOpacity: 0,
    stroke: "currentColor",
    strokeWidth: 6,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bqUhWSCBc",
    opacity: 1,
    fill: "currentColor",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c17inI8nhP",
    opacity: 1,
    fill: "currentColor",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#afgt56bsj",
    opacity: 1,
    fill: "currentColor",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e14M2lI70M",
    opacity: 1,
    fill: "currentColor",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b7abAKAWgE",
    opacity: 1,
    fill: "currentColor",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g2GRCIzFXr",
    opacity: 1,
    fill: "currentColor",
    fillOpacity: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStory);
export default __webpack_public_path__ + "static/media/story.2e5bc57f.svg";
export { ForwardRef as ReactComponent };